import React, {useEffect, useState} from 'react'
import {Col, Row, Spinner, Stack} from 'react-bootstrap'
import Chart from 'react-apexcharts'
import SVG from 'react-inlinesvg'
import ApprovedIcon from '../../../_metronic/images/ApprovedIcon.svg'
import PendingIcon from '../../../_metronic/images/PendingIcon.svg'
import RejectedIcon from '../../../_metronic/images/RejectedIcon.svg'
import {chartOptions} from '../../../utils/helper'

interface Props {
  tpvStatus: any
  reload: any
}

function TpvStatus({tpvStatus, reload}: Props) {
  const [total, setTotal] = useState<number>()
  const [tpvSeries, setTpvSeries] = useState<any>([])
  const [approved, setApproved] = useState<number>()
  const [pending, setPending] = useState<number>()
  const [rejected, setRejected] = useState<number>()

  useEffect(() => {
    const tpvStatusData = (data: any) => {
      const updatedTpvSeries: any = []
      for (let i = 0; i < data?.tpvStatus.length; i++) {
        if (data?.tpvStatus[i]?.qcStatus === 'ACCEPTED') {
          setApproved(data?.tpvStatus[i].qcStatusCount)
        } else if (data?.tpvStatus[i]?.qcStatus === 'REJECTED') {
          setRejected(data?.tpvStatus[i]?.qcStatusCount)
        } else if (data?.tpvStatus[i]?.qcStatus === 'AUTO_APPROVED') {
          setApproved((prev) => prev + data?.tpvStatus[i].qcStatusCount)
        } else {
          setPending(data?.tpvStatus[i]?.qcStatusCount)
        }
        updatedTpvSeries.push(data?.tpvStatus[i].qcStatusCount)
      }
      setTpvSeries(updatedTpvSeries)
      setTotal(data?.totalTpvStatus)
    }
    tpvStatusData(tpvStatus)
  }, [tpvStatus])

  const optionsTpvStatus: Object = chartOptions(
    ['Approved', 'Pending Review', 'Rejected'],
    ['#50CD89', '#F6C000', '#F1416C']
  )

  return (
    <div
      className='card card-flush card-border mb-5 mb-xl-110 h-auto'
      style={{minHeight: '365px', maxHeight: '365px'}}
    >
      <Stack gap={2} className='container mt-5 mb-5 ms-4'>
        <div className='text-dark fw-bolder fs-3'>QC Status</div>
        <Stack direction='horizontal' gap={2}>
          <div className='fw-bold fs-6 text-dark'>{total}</div>
          <div className='text-muted fs-6'>TPVs</div>
        </Stack>
      </Stack>

      {reload ? (
        <div className='text-center mb-20'>
          <Spinner animation='border' className='text-gray-600 text-center' role='status'>
            <span className='visually-hidden'>Loading...</span>
          </Spinner>
        </div>
      ) : (
        <div className='container mb-5'>
          <Row>
            <Col c sm md lg='7'>
              <div className='position-relative d-flex flex-center mb-7'>
                <Chart
                  type='donut'
                  height={270}
                  width={330}
                  series={tpvSeries}
                  options={optionsTpvStatus}
                />
              </div>
            </Col>
            <Col className='align-self-center' sm md lg='5'>
              <Stack gap={5}>
                <div className='d-flex mb-3 me-15'>
                  <SVG src={ApprovedIcon} className='me-3' />
                  <Stack>
                    <span className='fw-bold fs-2'>{approved}</span>
                    <span className='text-success fs-6'>Approved</span>
                  </Stack>
                </div>
                <div className='d-flex mb-3 me-15'>
                  <SVG src={PendingIcon} className='me-3' />
                  <Stack>
                    <span className='fw-bold fs-2'>{pending}</span>
                    <span className='text-warning fs-6'>Pending Review</span>
                  </Stack>
                </div>
                <div className='d-flex mb-3 me-15'>
                  <SVG src={RejectedIcon} className='me-3' />
                  <Stack>
                    <span className='fw-bold fs-2'>{rejected}</span>
                    <span className='text-danger fs-6'>Rejected</span>
                  </Stack>
                </div>
              </Stack>
            </Col>
          </Row>
        </div>
      )}
    </div>
  )
}

export default TpvStatus
